import { AxiosError } from 'axios';
import RepositoryFactory from '@/repository/RepositoryFactory';
import { UpdateAttendanceContactDeadlineRequest } from '@/model/repository/manager/parentContacts/AttendanceContactDeadlineRepository';

export const updateAttendanceContactDeadline = async (payload: UpdateAttendanceContactDeadlineRequest) => {
  try {
    const repository = RepositoryFactory.manager.attendanceContactDeadline;
    await repository.update(payload);
  } catch (e: unknown) {
    const err = e as AxiosError;
    if (err.response) {
      throw err.response;
    }
    throw new Error('通信エラーが発生しました');
  }
};
